import React, { useState, useRef, useEffect } from 'react';
import { MoreVertical, Pencil, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

export function ActionMenu({ onEdit, onDelete, editLabel = "Modifier", deleteLabel = "Supprimer", extraActions = [] }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div className="relative inline-flex items-center justify-end gap-2" ref={ref}>
      {/* Desktop: inline buttons */}
      <div className="hidden md:inline-flex items-center gap-2">
        {extraActions.map((action, i) => (
          <Button key={i} variant="outline" size="sm" onClick={action.onClick}>
            {action.label}
          </Button>
        ))}
        <Button variant="outline" size="sm" onClick={onEdit}>
          <Pencil className="h-4 w-4 mr-1" /> {editLabel}
        </Button>
        <Button variant="ghost" size="sm" className="text-destructive hover:text-destructive hover:bg-destructive/10" onClick={onDelete}>
          <Trash2 className="h-4 w-4 mr-1" /> {deleteLabel}
        </Button>
      </div>

      {/* Mobile/tablet: ⋮ dropdown */}
      <div className="md:hidden">
        <Button variant="ghost" size="sm" onClick={() => setOpen(!open)} aria-label="Actions">
          <MoreVertical className="h-4 w-4" />
        </Button>
        {open && (
          <div className="absolute right-0 top-full mt-1 w-40 rounded-md border bg-popover text-popover-foreground shadow-lg z-50">
            {extraActions.map((action, i) => (
              <button
                key={i}
                className="w-full flex items-center rounded-sm px-2 py-1.5 text-sm hover:bg-accent hover:text-accent-foreground"
                onClick={() => { setOpen(false); action.onClick(); }}
              >
                {action.label}
              </button>
            ))}
            <button
              className="w-full flex items-center rounded-sm px-2 py-1.5 text-sm hover:bg-accent hover:text-accent-foreground"
              onClick={() => { setOpen(false); onEdit(); }}
            >
              <Pencil className="mr-2 h-4 w-4" /> {editLabel}
            </button>
            <button
              className="w-full flex items-center rounded-sm px-2 py-1.5 text-sm text-destructive hover:bg-destructive/10"
              onClick={() => { setOpen(false); onDelete(); }}
            >
              <Trash2 className="mr-2 h-4 w-4" /> {deleteLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
